import React from 'react';
import { Navigate } from 'react-router-dom';
import { LOGIN_ROUTE } from 'routes/core/RouterConstants';

const AuthGuard = ({ children }) => {
  const secret_key = localStorage.getItem('key');

  if (secret_key) return children;
  else return <Navigate to={LOGIN_ROUTE} replace />;
};

export default AuthGuard;
